import React from 'react';

import classNames from 'classnames/bind';

import Heading from '../TextComponents/Heading';
import Text from '../TextComponents/Text';
import type {DropdownOptionWithHeading} from './index';

import styles from './styles.module.scss';

const cx = classNames.bind(styles);

type DropdownItemProps = {
  index: number;
  style: React.CSSProperties;
  data: {
    filteredOptions: DropdownOptionWithHeading[];
    activeIndex: number;
    optionDataAutomation?: string;
    leftOptionDataAutomation?: string;
    rightOptionDataAutomation?: string;
    onHover: (index: number) => void;
    onClick: (index: number) => void;
  };
};

const DropdownItem = (props: DropdownItemProps) => {
  const {index, style} = props;
  const {filteredOptions, activeIndex, onHover, onClick} = props.data;
  const item = filteredOptions[index];

  if (item === undefined) {
    return null;
  }

  return (
    <div style={style} onMouseMove={() => onHover(index)}>
      {item.heading && (
        <>
          {index > 0 && <hr className={cx('divider')} />}
          <div className={cx('heading')}>
            <Heading as='h6' size='ant' weight='medium' colour='grey700'>
              {item.heading}
            </Heading>
          </div>
        </>
      )}
      <div
        className={cx('dropdown-option', {
          active: index === activeIndex,
          disabled: item.disabled,
        })}
        onMouseDown={() => onClick(index)}
        data-automation={item.optionDataAutomation}
      >
        <div className={cx('left-content')}>
          {item.leftIcon}
          <Text size='m' dataAutomation={item.leftOptionDataAutomation}>
            {item.label}
          </Text>
        </div>
        <div className={cx('right-content')}>
          {item.icon}
          {item.rightText && (
            <Text
              size='s'
              colour='grey700'
              dataAutomation={item.rightOptionDataAutomation}
            >
              {item.rightText}
            </Text>
          )}
        </div>
      </div>
    </div>
  );
};

export default DropdownItem;
